import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const Neighborhoods = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Neighborhoods"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddNeighborhood = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Neighborhood"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditNeighborhood = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Neighborhood"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};
